import { XCloseGray } from "../icons/XClose";
import { Column } from "./Column";

export const ProfileViewImage = ({ Ref, children, selectImage, handleIsSelected }: {Ref?: React.RefObject<HTMLElement>, handleIsSelected?: () => void, children?: React.ReactNode, selectImage: string}) => {
    return (
        <article
            {...(Ref ? { ref: Ref } : {})}
            className={`fixed z-30 top-0 left-0 w-full sm:w-[30rem] h-full sm:h-4/5 sm:max-h-[43rem] sm:top-1/2 sm:left-1/2 transform sm:-translate-x-1/2 sm:-translate-y-1/2 transition-transform`}
        >
            <Column
                className="w-full sm:w-[30rem] h-full sm:max-h-[43rem] bg-black overflow-y-auto gap-4 sm:gap-5 sm:rounded-xl"
            >
                {handleIsSelected &&
                    <button
                        onClick={handleIsSelected}
                        aria-label="Close Preview Profile"
                        className="text-white hover:text-grayLight2 absolute z-30 top-5 sm:top-0 right-5 sm:-right-8 max-sm:self-end"
                    >
                        <XCloseGray />
                    </button>
                }
                <picture className="flex items-center py-10 w-full h-full relative rounded-xl">
                    <img
                        className="object-contain w-full h-full rounded-xl"
                        src={selectImage}
                        alt="image-view"
                    />
                </picture>
                {children}
            </Column>
        </article>
    );
};